<template>
    <div class="car-add-form-container">
        <div class="page-title-container lighter-shadow" style="text-align: center;">
            <i class="fas fa-car-side icon"></i>
            <h1>Добавяне на автомобил</h1>
        </div>
        <form class="page-content lighter-shadow" style="padding-top: 20px;">
            <InputText class="input"
                       @value-change="setAttribute"
                       :id="'brand'"
                       :name="'brand'"
                       :label="'Марка'"
                       :placeholder="'Въведете марка'"
                       :showError="shouldShowError('brand')">
            </InputText>
            <ErrorInput class="error" v-if="shouldShowError('brand')" :text="errors['brand']"/>

            <InputText class="input"
                       @value-change="setAttribute"
                       :id="'model'"
                       :name="'model'"
                       :label="'Модел'"
                       :placeholder="'Въведете модел'"
                       :showError="shouldShowError('model')">
            </InputText>
            <ErrorInput class="error" v-if="shouldShowError('model')" :text="errors['model']"/>

            <InputText class="input"
                       @value-change="setAttribute"
                       :id="'registrationNumber'"
                       :name="'registrationNumber'"
                       :label="'Регистрационен номер'"
                       :placeholder="'Въведете регистрационен номер'"
                       :showError="shouldShowError('registrationNumber')">
            </InputText>
            <ErrorInput class="error" v-if="shouldShowError('registrationNumber')"
                        :text="errors['registrationNumber']"/>

            <CarCategoryDropdown class="enum-dropdown"
                                 :id="'categoryDropdown'"
                                 :label="'Категория'"
                                 @selection-change="categorySelected"/>

            <CarTypeDropdown class="enum-dropdown"
                             :id="'typeDropdown'"
                             :label="'Тип'"
                             @selection-change="typeSelected"/>

            <InputText class="input"
                       @value-change="setAttribute"
                       :id="'seats'"
                       :name="'seats'"
                       :label="'Брой места'"
                       :isNumber="true"
                       :placeholder="'Въведете брой места'"
                       :showError="shouldShowError('seats')">
            </InputText>
            <ErrorInput class="error" v-if="shouldShowError('seats')" :text="errors['seats']"/>

            <InputText class="input"
                       @value-change="setAttribute"
                       :id="'tax'"
                       :name="'tax'"
                       :label="'Данък (лв.)'"
                       :isNumber="true"
                       :placeholder="'Въведете данък'"
                       :showError="shouldShowError('tax')">
            </InputText>
            <ErrorInput class="error" v-if="shouldShowError('tax')" :text="errors['tax']"/>

            <Button class="save-button"
                    @click.native="addWorker"
                    :color="'green'"
                    :text="'Запази'"
                    :icon="'fa fa-save'"></Button>
        </form>
    </div>
</template>

<script>
    import InputText from "@/shared/components/form/InputText";
    import Button from "@/shared/components/button/Button";
    import ErrorInput from "@/shared/components/form/ErrorInput";
    import redirectService from "@/services/redirect.service";
    import authorizationService from "@/services/authorization.service";
    import carService from "@/services/car.service";

    export default {
        name: "CarAdd",
        components: {ErrorInput, Button, InputText},
        created() {
            authorizationService.checkIsLoggedIn();
            this.$store.dispatch('fetchCarEnums');
        },
        data() {
            return {
                car: {
                    category: {
                        enumName: null
                    },
                    type: {
                        enumName: null
                    }
                },
                errors: {}
            }
        },
        methods: {
            setAttribute(value) {
                this.car[value.name] = value.currentValue;
                this.errors[value.name] = null;
            },
            categorySelected(event) {
                if (event.currentValue) {
                    this.car.category.enumName = event.currentValueId;
                } else {
                    this.car.category.enumName = null;
                }
            },
            typeSelected(event) {
                if (event.currentValue) {
                    this.car.type.enumName = event.currentValueId;
                } else {
                    this.car.type.enumName = null;
                }
            },
            addWorker() {
                carService.addCar(this.car)
                    .then(({data}) => redirectService.redirectToCarInfo(data))
                    .catch((errors) => this.errors = errors.response.data.errors);
            },
            shouldShowError(fieldName) {
                return !!(this.errors && this.errors[fieldName]);
            }
        }
    }
</script>

<style scoped>
    .car-add-form-container {
        width: 750px;
        height: fit-content;
        margin: 0 auto 60px auto;
    }

    .input {
        display: block;
        width: 500px;
        height: 95px;
        margin: 20px auto 0 auto;
    }

    .error {
        width: 500px;
        margin-top: -7px;
    }

    .save-button {
        width: 300px;
        height: 60px;
        font-size: 26px;
        margin: 45px;
    }

    .enum-dropdown {
        width: 500px;
        height: 95px;
        margin: 20px auto 0 auto;
    }
</style>
